import { render, staticRenderFns } from "./graficaAvanceFisico.vue?vue&type=template&id=5efdf34c&scoped=true&"
import script from "./graficaAvanceFisico.vue?vue&type=script&lang=js&"
export * from "./graficaAvanceFisico.vue?vue&type=script&lang=js&"
import style0 from "./graficaAvanceFisico.vue?vue&type=style&index=0&id=5efdf34c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efdf34c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VContainer,VDivider,VSimpleTable})
